import * as t from "io-ts";

export const FilterTCodec = t.intersection([
  t.type({
    key: t.string,
    label: t.string,
    type: t.string,
    values: t.array(t.string),
  }),
  t.partial({
    isSelected: t.union([t.boolean, t.undefined]),
    items: t.union([
      t.undefined,
      t.array(
        t.type({
          value: t.string,
          label: t.string,
        })
      ),
    ]),
    condition: t.union([t.string, t.undefined]),
    logic: t.union([t.literal("AND"), t.literal("OR"), t.undefined]),
    subMode: t.union([t.string, t.undefined]),
  }),
]);

export const FilterTArrayCodec = t.array(FilterTCodec);
export type FilterT = t.TypeOf<typeof FilterTCodec>;

export const filterArray: FilterT[] = [
  {
    key: "location",
    label: "Location",
    type: "multiSelect",
    isSelected: true,
    condition: "is_any",
    values: [],
    items: [
      { value: "london", label: "London" },
      { value: "manchester", label: "Manchester" },
      { value: "birmingham", label: "Birmingham" },
      { value: "leeds", label: "Leeds" },
      { value: "glasgow", label: "Glasgow" },
      { value: "sheffield", label: "Sheffield" },
      { value: "bradford", label: "Bradford" },
      { value: "liverpool", label: "Liverpool" },
      { value: "edinburgh", label: "Edinburgh" },
      { value: "bristol", label: "Bristol" },
      { value: "cardiff", label: "Cardiff" },
      { value: "leicester", label: "Leicester" },
      { value: "coventry", label: "Coventry" },
      { value: "nottingham", label: "Nottingham" },
      { value: "hull", label: "Hull" },
      { value: "newcastle", label: "Newcastle" },
      { value: "belfast", label: "Belfast" },
      { value: "stoke", label: "Stoke-on-Trent" },
      { value: "southampton", label: "Southampton" },
      { value: "derby", label: "Derby" },
      { value: "portsmouth", label: "Portsmouth" },
      { value: "brighton", label: "Brighton" },
      { value: "plymouth", label: "Plymouth" },
      { value: "northampton", label: "Northampton" },
      { value: "reading", label: "Reading" },
      { value: "luton", label: "Luton" },
      { value: "wolverhampton", label: "Wolverhampton" },
      { value: "bolton", label: "Bolton" },
      { value: "bournemouth", label: "Bournemouth" },
      { value: "norwich", label: "Norwich" },
      { value: "swindon", label: "Swindon" },
      { value: "swansea", label: "Swansea" },
      { value: "southend", label: "Southend-on-Sea" },
      { value: "middlesbrough", label: "Middlesbrough" },
      { value: "oxford", label: "Oxford" },
      { value: "cambridge", label: "Cambridge" },
      { value: "blackpool", label: "Blackpool" },
      { value: "ipswich", label: "Ipswich" },
      { value: "york", label: "York" },
      { value: "gloucester", label: "Gloucester" },
      { value: "exeter", label: "Exeter" },
      { value: "bath", label: "Bath" },
      { value: "chester", label: "Chester" },
      { value: "dundee", label: "Dundee" },
      { value: "aberdeen", label: "Aberdeen" },
      { value: "stirling", label: "Stirling" },
      { value: "inverness", label: "Inverness" },
      { value: "perth", label: "Perth" },
      { value: "bangor", label: "Bangor" },
      { value: "newport", label: "Newport" },
      { value: "wrexham", label: "Wrexham" },
    ],
  },
  {
    key: "industry",
    label: "Industry",
    type: "multiSelect",
    isSelected: true,
    condition: "is_any",
    values: [],
    items: [
      {
        label: "Adtech",
        value: "adtech",
      },
      {
        label: "Agritech",
        value: "agritech",
      },
      {
        label: "Artificial Intelligence",
        value: "artificial_intelligence",
      },
      {
        label: "Automotive Technology",
        value: "automotive_technology",
      },
      {
        label: "Aviation Technology",
        value: "aviation_technology",
      },
      {
        label: "Biotech",
        value: "biotech",
      },
      {
        label: "Biotechnology",
        value: "biotechnology",
      },
      {
        label: "Cleantech",
        value: "cleantech",
      },
      {
        label: "Climate Tech",
        value: "climate_tech",
      },
      {
        label: "Climatetech",
        value: "climatetech",
      },
      {
        label: "Constructiontech",
        value: "constructiontech",
      },
      {
        label: "Consumer",
        value: "consumer",
      },
      {
        label: "Cryptocurrency",
        value: "cryptocurrency",
      },
      {
        label: "Cybersecurity",
        value: "cybersecurity",
      },
      {
        label: "Data Analytics",
        value: "data analytics",
      },
      {
        label: "Deeptech",
        value: "deeptech",
      },
      {
        label: "Defenctechnology",
        value: "defenctechnology",
      },
      {
        label: "Devops",
        value: "devops",
      },
      {
        label: "Ecommerce",
        value: "ecommerce",
      },
      {
        label: "Edtech",
        value: "edtech",
      },
      {
        label: "Electric Vehicles",
        value: "electric_vehicles",
      },
      {
        label: "Energy",
        value: "energy",
      },
      {
        label: "Entertainment",
        value: "entertainment",
      },
      {
        label: "Fintech",
        value: "fintech",
      },
      {
        label: "Fitness",
        value: "fitness",
      },
      {
        label: "Foodtech",
        value: "foodtech",
      },
      {
        label: "Gaming",
        value: "gaming",
      },
      {
        label: "Hrtech",
        value: "hrtech",
      },
      {
        label: "Healthtech",
        value: "Healthtech",
      },
      {
        label: "Healthcare",
        value: "Healthcare",
      },
      {
        label: "Industrial",
        value: "industrial",
      },
      {
        label: "Insuretech",
        value: "insuretech",
      },
      {
        label: "Insurtech",
        value: "insurtech",
      },
      {
        label: "Iot",
        value: "iot",
      },
      {
        label: "Legaltech",
        value: "legaltech",
      },
      {
        label: "Logistics",
        value: "logistics",
      },
      {
        label: "Media",
        value: "media",
      },
      {
        label: "Medtech",
        value: "medtech",
      },
      {
        label: "Metaverse",
        value: "metaverse",
      },
      {
        label: "Other",
        value: "other",
      },
      {
        label: "Proptech",
        value: "proptech",
      },
      {
        label: "Quantum Computing",
        value: "quantum_computing",
      },
      {
        label: "Regtech",
        value: "regtech",
      },
      {
        label: "Robotics",
        value: "robotics",
      },
      {
        label: "Saas",
        value: "saas",
      },
      {
        label: "Semiconductor Technology",
        value: "semiconductor_technology",
      },
      {
        label: "Social Media",
        value: "social_media",
      },
      {
        label: "Spacetech",
        value: "spacetech",
      },
      {
        label: "Sustainability",
        value: "sustainability",
      },
      {
        label: "Telecom",
        value: "telecom",
      },
      {
        label: "Transport",
        value: "transport",
      },
      {
        label: "Web3",
        value: "web3",
      },
    ],
  },
  {
    key: "founding_year",
    label: "Founding Year",
    type: "calendar",
    isSelected: true,
    condition: "in_year",
    values: [],
  },
  {
    key: "investor",
    label: "Investor",
    type: "multiSelect",
    condition: "is_any",
    items: [
      { value: "late stage", label: "Late Stage" },
      { value: "early stage", label: "Early Stage" },
      { value: "vc", label: "VC's" },
      { value: "pe", label: "PE" },
      { value: "banks", label: "Banks" },
      { value: "angels", label: "Angels" },
    ],
    values: [],
  },
  {
    key: "company_highlights",
    label: "Company Highlights",
    type: "multiSelect",
    condition: "is_any",
    values: [],
  },
  {
    key: "last_funding_stage",
    label: "Last Funding Stage",
    type: "multiSelect",
    condition: "is_any",
    values: [],
    items: [
      { value: "seed", label: "Seed" },
      { value: "series_a", label: "Series A" },
      { value: "series_b", label: "Series B" },
    ],
  },
  {
    key: "funding_amount",
    label: "Funding Amount",
    type: "number",
    condition: "in_between",
    values: [],
  },
  {
    key: "revenue",
    label: "Revenue",
    type: "number",
    condition: "in_between",
    values: [],
  },
  {
    key: "team_size",
    label: "Team size",
    type: "number",
    condition: "in_between",
    values: [],
  },
  {
    key: "last_funding_stage",
    label: "Last funding stage",
    type: "multiSelect",
    condition: "is_any",
    values: [],
    items: [
      { value: "seed", label: "Seed" },
      { value: "series_a", label: "Series A" },
      { value: "series_b", label: "Series B" },
    ],
  },
  {
    key: "exit_status",
    label: "Exit Status",
    type: "multiSelect",
    condition: "is_any",
    values: [],
    items: [
      { value: "ipo", label: "IPO" },
      { value: "acquire", label: "Acquire" },
      { value: "merger", label: "Merger" },
      { value: "shutdown", label: "Shutdown" },
    ],
  },
  {
    key: "technology_stack",
    label: "Technology Stack",
    type: "multiSelect",
    condition: "is_any",
    values: [],
  },
  {
    key: "founder_background",
    label: "Founder Background",
    type: "multiSelect",
    condition: "is_any",
    values: [],
    items: [
      { value: "stanford", label: "Stanford" },
      { value: "harvard", label: "Harvard" },
    ],
  },
];

export const conditions = [
  { label: "Include", value: "is_any" },
  { label: "Exclude", value: "not_in" },
];

export const numberConditions = [
  { label: "Greater than", value: "gt" },
  { label: "Less than", value: "lt" },
  { label: "Range Between", value: "in_between" },
];
export const calendarConditions = [
  { label: "In Year", value: "in_year" },
  { label: "In Quarter", value: "in_quarter" },
  { label: "Between Year", value: "between_year" },
  { label: "Between Quarter", value: "between_quarter" },
  { label: "Between Date", value: "between_date" },
];
